import { useGetGeolocalizzazioneComuni } from '@framework/api-client';
import { ISelectInputProps, SelectInput } from '@framework/form';
import * as React from 'react';

export interface IMapMunicipalitySelectInputProps extends ISelectInputProps {
  name: string;
}

export function MapMunicipalitySelectInput(
  props: IMapMunicipalitySelectInputProps,
) {
  const { name, ...otherProps } = props;
  const { data, isFetching, isLoading } = useGetGeolocalizzazioneComuni({
    query: {
      enabled: true,
    },
  });

  return (
    <SelectInput
      {...otherProps}
      name={name}
      loading={isFetching || isLoading}
      searchable
      options={data?.comuni?.map(municipality => ({
        // Potremmo usare il codice ISTAT come value, dipende dagli Endpoint
        value: municipality.codiceBelfiore!, // 'A944' per esempio
        label: `${municipality.nome ?? ''} (${municipality.provincia ?? ''})`,
        municipality,
      }))}
    />
  );
}
